module.exports = __webpack_public_path__ + "static/media/MEMBRESIA FREE.9c017607.png";